import * as React from 'react';
import { Modal } from 'react-bootstrap';
import {
    HiOutlineShieldExclamation,
    HiOutlineDeviceMobile,
    HiOutlineCheckCircle,
    HiOutlinePhone,
    HiOutlineRefresh,
} from 'react-icons/hi';

interface IProps
{
    show: boolean;
    onHide: () => void;
}

// Exibido quando a Api.Industria sinaliza VerifyPersonViewModel.SerasaRestricted no
// CPF do paciente: o CPF existe no Serasa, mas está bloqueado para consultas de
// terceiros. A mensagem inline do formulário segue genérica; a orientação de como
// remover a restrição fica aqui.
export const SerasaRestrictionModal = (props: IProps) =>
    <Modal show={props.show} onHide={props.onHide} centered className="serasa-restriction">
        <Modal.Header closeButton />
        <Modal.Body>
            <div className="serasa-restriction__heading">
                <div className="serasa-restriction__icon">
                    <HiOutlineShieldExclamation />
                </div>

                <div className="serasa-restriction__title">
                    CPF com restrição de consulta no Serasa
                </div>
            </div>

            <p className="serasa-restriction__text">
                Não conseguimos validar seus dados porque seu CPF está bloqueado para consultas de terceiros.
                Para continuar o cadastro, você precisa remover essa restrição diretamente no Serasa.
            </p>

            <div className="serasa-restriction__section-title">
                <HiOutlineDeviceMobile /> Pelo app ou site da Serasa
            </div>

            <div className="serasa-restriction__card">
                <HiOutlineCheckCircle className="serasa-restriction__card-icon" />
                <span>Acesse o app Serasa (ou serasa.com.br) e faça login com CPF e senha.</span>
            </div>
            <div className="serasa-restriction__card">
                <HiOutlineCheckCircle className="serasa-restriction__card-icon" />
                <span>Vá em &quot;Segurança&quot; ou &quot;Meus Alertas / Serasa Protege&quot;.</span>
            </div>
            <div className="serasa-restriction__card">
                <HiOutlineCheckCircle className="serasa-restriction__card-icon" />
                <span>Localize a opção &quot;Bloqueio de CPF&quot;.</span>
            </div>
            <div className="serasa-restriction__card">
                <HiOutlineCheckCircle className="serasa-restriction__card-icon" />
                <span>Toque em &quot;Desbloquear&quot; e confirme sua identidade.</span>
            </div>
            <div className="serasa-restriction__card">
                <HiOutlineCheckCircle className="serasa-restriction__card-icon" />
                <span>A liberação costuma ser imediata, mas pode levar algumas horas.</span>
            </div>

            <div className="serasa-restriction__section-title">
                <HiOutlinePhone className="serasa-restriction__section-icon" /> Por telefone
            </div>

            <div className="serasa-restriction__card">
                <div className="serasa-restriction__card-content">
                    <div>
                        Central Serasa: <a href="tel:+5508005911222">0800 591 1222</a>
                    </div>
                    <div className="serasa-restriction__muted">Atendimento automático e humano.</div>
                </div>
            </div>

            <div className="serasa-restriction__card serasa-restriction__note">
                <HiOutlineRefresh className="serasa-restriction__card-icon" />
                <span>
                    <strong>Depois de tirar a restrição:</strong> volte aqui no site e finalize seu cadastro
                    normalmente. A validação dos dados será refeita automaticamente.
                </span>
            </div>
        </Modal.Body>
    </Modal>

export default SerasaRestrictionModal;
